import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import * as globals from '../globals';
import { AuthHttp, AuthConfig } from 'angular2-jwt';



@Injectable()
export class QuoteService {

  private quoteUrl = globals.APIURL + '/admin/quote';
  private quoteprojectUrl = this.quoteUrl + '/quoteproject';
  private quoteprojectquantityUrl = this.quoteUrl + '/quoteprojectquantity';
  private customerurl = globals.APIURL + '/customer';
  private recipeProjectUrl = globals.APIURL + '/projects/recipe';
  private quotepdfUrl = this.quoteUrl + '/pdf';
  // private projectsUrl = globals.APIURL + '/projects';
  constructor(private http: Http, public authHttp: AuthHttp) { }

  // getQuotes(): Observable<string> {
  //   let headers = new Headers({
  //     'Content-Type': 'application/json'
  //   });

  //   let options = new RequestOptions({ body: '', headers: headers });

  //   return this.authHttp.get(this.quoteUrl, options)
  //     .map(this.extractData)
  //     .catch(this.handleError);
  // }

  getQuotes(quoteconfig): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      currentPage: quoteconfig.currentPage,
      itemsPerPage: quoteconfig.itemsPerPage
    });

    let options = new RequestOptions({ headers: headers });

    return this.authHttp.post(this.quoteUrl + '/page', body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  advancedSearchQuote(quoteconfig, searchTerms, advSearch): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      currentPage: quoteconfig.currentPage,
      itemsPerPage: quoteconfig.itemsPerPage,
      searchterms: { number: searchTerms.number, createdate: searchTerms.createddate, createddays: searchTerms.createdays, RFQ: searchTerms.RFQ, customer: searchTerms.customer, contact: searchTerms.contact, duedate: searchTerms.duedate, duedays: searchTerms.duedays, owner: searchTerms.owner, status: searchTerms.status, expireddate: searchTerms.expireddate, expireddays: searchTerms.expireddays,  advancedSearch: advSearch }
    });

    console.log('in advancedSearchQuote', body);
    console.log(searchTerms);

    let options = new RequestOptions({ headers: headers });

    return this.authHttp.post(this.quoteUrl + '/page', body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getCustomers(): Observable<string> {
    console.log('get users service called');
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });
    console.log('Projects: OPTIONS =>', options);
    console.log('URL:', this.customerurl);
    return this.authHttp.get(this.customerurl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getMaterials(): Observable<string> {
    console.log('get users service called');
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });
    console.log('Projects: OPTIONS =>', options);
    console.log('URL:', this.customerurl);
    return this.authHttp.get(this.customerurl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getRecipesProject(projectid): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.get(this.recipeProjectUrl + '/' + projectid, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  addQuote(quote: any, quoteprojects: any): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      quote: quote,
      quoteprojects: quoteprojects
    });

    let options = new RequestOptions({ headers: headers });

    return this.authHttp.post(this.quoteUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  addQuoteProject(quoteprojects: any, quoteprojectquantities: any): Observable<string> {

    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      quoteproject: quoteprojects, quoteprojectquantities: quoteprojectquantities
    });

    let options = new RequestOptions({ headers: headers });

    return this.authHttp.post(this.quoteprojectUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  updateQuoteprojectquantity(quoteprojects: any): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      quoteprojects: quoteprojects
    });

    let options = new RequestOptions({ headers: headers });

    return this.authHttp.put(this.quoteprojectquantityUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  updateQuoteProject(quoteprojects: any, quoteprojectquantities: any): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      quoteproject: quoteprojects, quoteprojectquantities: quoteprojectquantities
    });

    let options = new RequestOptions({ headers: headers });

    return this.authHttp.put(this.quoteprojectUrl + '/' + quoteprojects.id, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

 createQuotePDF(pdfquotedetails: any): Observable<string> {
  let headers = new Headers({
    'Content-Type': 'application/json'
  });

  let body = JSON.stringify({
    tenantid : pdfquotedetails.tenantid,
    companyLogoUrl : pdfquotedetails.companyLogoUrl,
    planid : pdfquotedetails.planid,
    quoteid : pdfquotedetails.quoteid,
    quote_number: pdfquotedetails.quote_number,
    quote_to : pdfquotedetails.quote_to,
    ship_to : pdfquotedetails.ship_to,
    create_date: pdfquotedetails.create_date,
    expiration_date : pdfquotedetails.expiration_date,
    terms : pdfquotedetails.terms,
    Ship_via : pdfquotedetails.Ship_via,
    Sales_Person : pdfquotedetails.Sales_Person,
    Sales_Person_contact : pdfquotedetails.Sales_Person_contact,
    quote_projects : pdfquotedetails.quote_projects,
    dateFormat: pdfquotedetails.dateFormat,
    currencyName: pdfquotedetails.currencyName,
    currencySymbol: pdfquotedetails.currencySymbol,
    websiteurl : pdfquotedetails.websiteurl,
    quote_contact_info : pdfquotedetails.quote_contact_info,
    quote_document_footer : pdfquotedetails.quote_document_footer
  })

  let options = new RequestOptions({ headers: headers });

  return this.authHttp.post(this.quotepdfUrl, body, options)
    .map(this.extractData)
    .catch(this.handleError);  
 }

  updateQuote(quoteValues: any): Observable<string> {

    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      rfq: quoteValues.rfq,
      customer_id: quoteValues.customer_id,
      customercontact_id: quoteValues.customercontact_id,
      shipvia_id: quoteValues.shipvia_id,
      quoteterms_id: quoteValues.quoteterms_id,
      estimated_quote_value: quoteValues.estimated_quote_value,
      expiration_date: quoteValues.expiration_date,
      due_date: quoteValues.due_date,
      owner_id: quoteValues.owner_id,
      quotestatus_id: quoteValues.quotestatus_id,
      win_probability: quoteValues.win_probability
    });


    let options = new RequestOptions({ headers: headers });
    return this.authHttp.put(this.quoteUrl + '/' + quoteValues.id, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  updateQuoteComment(quoteValues: any, comment): Observable<string> {

    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      comment_id: comment
    });

    let options = new RequestOptions({ headers: headers });
    return this.authHttp.put(this.quoteUrl + '/' + quoteValues.id, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  deleteQuote(id: any): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.delete(this.quoteUrl + '/' + id, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  deleteQuoteProject(id: any): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.delete(this.quoteprojectUrl + '/' + id, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
  }

  private extractData(res: Response) {
    let body = res.json();
    return body || {};
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/quote/quote.service.ts